/**
 * useCollaboration - Collaboration state management
 *
 * Provides collaboration API, isCollaborating, isOffline, collabError,
 * share dialog state, and localStorageQuotaExceeded.
 *
 * Extracted from App.tsx lines 558–570, 904–968
 */

import { useCallback } from "react";

import { isRunningInIframe } from "@excalidraw/common";

import { useAtom, useAtomValue, useAtomWithInitialValue } from "../app-jotai";
import {
  collabAPIAtom,
  isCollaboratingAtom,
  isOfflineAtom,
} from "../collab/Collab";
import { collabErrorIndicatorAtom } from "../collab/CollabError";
import { shareDialogStateAtom } from "../share/ShareDialog";
import { localStorageQuotaExceededAtom } from "../data/LocalData";
import { isCollaborationLink } from "../data";

export const useCollaboration = () => {
  const isCollabDisabled = isRunningInIframe();

  const [, setShareDialogState] = useAtom(shareDialogStateAtom);
  const [collabAPI] = useAtom(collabAPIAtom);
  const [isCollaborating] = useAtomWithInitialValue(isCollaboratingAtom, () => {
    return isCollaborationLink(window.location.href);
  });
  const collabError = useAtomValue(collabErrorIndicatorAtom);
  const isOffline = useAtomValue(isOfflineAtom);
  const localStorageQuotaExceeded = useAtomValue(localStorageQuotaExceededAtom);

  const onCollabDialogOpen = useCallback(
    () => setShareDialogState({ isOpen: true, type: "collaborationOnly" }),
    [setShareDialogState],
  );

  return {
    isCollabDisabled,
    collabAPI,
    isCollaborating,
    collabError,
    isOffline,
    localStorageQuotaExceeded,
    setShareDialogState,
    onCollabDialogOpen,
  };
};
